import { render, staticRenderFns } from "./LoginActionButton.vue?vue&type=template&id=0f7ca660&"
import script from "./LoginActionButton.vue?vue&type=script&lang=js&"
export * from "./LoginActionButton.vue?vue&type=script&lang=js&"
import style0 from "./LoginActionButton.vue?vue&type=style&index=0&id=0f7ca660&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports